<ng-container
  *ngrxLet="{
    isStickyHeaderVisible: isStickyHeaderVisible$,
    showLabel: showLabel$,
  } as vm"
>
  @if (!hideStickyHeader && vm.isStickyHeaderVisible && !productAlternativeUI) {
    <mkp-product-sticky-header
      [isProductLoading]="isProductLoading"
      [products]="products"
      [activePlatformGroup]="activePlatformGroup"
      [showLabel]="vm.showLabel"
      [isReadMode]="isReadMode"
      [scrollConfig]="scrollConfig"
      (handleSelectedProduct)="productSelected.emit($event)"
    />
  }

  <div
    #tableLayout
    class="table-layout product-offering-layout"
    [class.layout-product-alternative-ui]="productAlternativeUI"
    [mkpDataTest]="'product-table-' + activePlatformGroup"
  >
    <div
      class="table-column-header-placeholder product-offering-placeholder"
      mkpInViewportNotifier
      [class.left-shadow]="tableLayout.scrollLeft > 0"
      [rootMargin]="-100"
      (visibilityChange)="this.isStickyHeaderVisible$.next(!$event)"
    >
      @if (tableLayout.scrollLeft > 0) {
        <div class="scroll-placeholder scroll-placeholder-left">
          <ui-button
            mkpDataTest="scroll-products-left-btn"
            mkpScrollToNext
            position="left"
            [config]="scrollConfig.left"
            [scrollableElement]="tableLayout"
            [itemsWrapperElement]="itemsWrapper"
            [length]="products?.length"
            (click)="productScrolled.emit('left')"
          >
            <ui-asset name="arrow_left" />
            @if (vm.showLabel) {
              <span>{{ 'PRODUCT_OFFERING.TABLE.SCROLL' | translate }}</span>
            }
          </ui-button>
        </div>
      }
    </div>
    <div #itemsWrapper class="table-column-headers" [class.center-column]="products?.length === 1">
      @if (products?.length) {
        @for (product of products; track product.code) {
          <mkp-product-card
            [isLoading]="product.code === isProductLoading"
            [isReadMode]="isReadMode"
            [isCollapsed]="false"
            [product]="product"
            [platforms]="platforms"
            [benefits]="benefits"
            [productAlternativeUI]="productAlternativeUI"
            [discountLineThrough]="discountLineThrough"
            [activePlatformGroup]="activePlatformGroup"
            (handleSelectedProduct)="productSelected.emit($event)"
          />
        }
      } @else {
        <mkp-cards-skeleton />
      }
    </div>
    @if (!productAlternativeUI) {
      <div
        class="table-row-headers product-offering-placeholder"
        [class.left-shadow]="tableLayout.scrollLeft > 0"
      >
        @if (platforms) {
          <div class="table-row-header title title-xxs">
            {{ 'PRODUCT_OFFERING.PLATFORMS' | translate }}
          </div>
        }
        @if (platforms) {
          @for (platform of platforms; track platform) {
            <ui-product-platform-cell
              class="table-row-header"
              [platform]="platform"
              [showTooltip]="true"
            />
          }
        } @else {
          <mkp-product-table-skeleton />
        }
        @if (benefits) {
          <div class="table-row-header title title-xxs">
            {{ 'PRODUCT_OFFERING.BENEFITS' | translate }}
          </div>
        }
        @if (benefits) {
          @for (benefit of benefits; track benefit) {
            <mkp-product-table-row-header-feature
              class="table-row-header"
              [benefit]="benefit"
              [showTooltip]="true"
            />
          }
        } @else {
          <mkp-cards-skeleton />
        }
        <div class="table-row-header-placeholder"></div>
      </div>
    }
    @if (!productAlternativeUI) {
      <div
        class="table-columns product-offering-columns"
        [class.center-column]="products?.length === 1"
        [class.skeleton-columns]="!products"
      >
        @if (products?.length) {
          @for (product of products; track product.code) {
            <mkp-product-table-column
              [product]="product"
              [platforms]="platforms"
              [benefits]="benefits"
              [activePlatformGroup]="activePlatformGroup"
            />
          }
        } @else {
          @for (skeleton of skeletons; track skeleton) {
            <mkp-product-table-column-skeleton />
          }
        }
      </div>
    }
    @if (!hideStickyHeader) {
      <div
        class="table-column-footer-placeholder product-offering-placeholder"
        [class.left-shadow]="tableLayout.scrollLeft > 0"
      ></div>
    }
  </div>
  <section
    class="scroll-placeholder-wrapper"
    [class.scroll-placeholder-wrapper-background]="hideStickyHeader"
  >
    @if (tableLayout.scrollWidth - tableLayout.offsetWidth > tableLayout.scrollLeft) {
      <div class="scroll-placeholder scroll-placeholder-right">
        <ui-button
          mkpScrollToNext
          mkpDataTest="scroll-products-right-btn"
          [config]="scrollConfig.right"
          [scrollableElement]="tableLayout"
          [itemsWrapperElement]="itemsWrapper"
          [length]="products?.length"
          (click)="productScrolled.emit('right')"
        >
          <ui-asset name="arrow_right" />
          @if (vm.showLabel) {
            <span>{{ 'PRODUCT_OFFERING.TABLE.SCROLL' | translate }}</span>
          }
        </ui-button>
      </div>
    }
  </section>
</ng-container>
